<template>
    <div
        class="col-md-4 col-lg-3 col-xl-2 ml-xs-0 mr-md-4 card mb-3"
        v-bind:class="{
            'card-selected': isServiceSelected,
            'card-disabled': !isServiceEntitled || isDisabledForFreeServiceRemaining,
            'card-selectable': isServiceEntitled
        }"
        v-bind:style="serviceCardStyle"
        data-toggle="tooltip"
        :title="toolTipMessage"
        :data-service-setting-id="service.service_setting_id"
    >
        <div
            class="pt-md-3 pb-md-3 card-saved"
            tabindex="0" 
            @keydown="selectServiceKeyEvent"
        >
            <div
                class="card-body card-body--forcharging d-flex align-items-center justify-content-start flex-md-column justify-content-md-center"
            >
              <!-- <ColorFilter> -->
                <img
                    v-show="service.icon"
                    class="card-icon"
                    :class="{ 'card-icon-disabled': !isServiceEntitled }"
                    :src="'storage/' + service.icon"
                    v-error-img-load
                />
                <i v-show="!service.icon" class="icon-binsandskips text-center"></i>
              <!-- </ColorFilter> -->
                <span class="text-center pt-md-3 pl-3 pl-md-0">{{
                    service.service_name
                }}</span>
            </div>
            <div
                v-show="isServiceSelected"
                class="card-body-selected"
                :style="'background-color:' + MainUISettings.button_color"
            >
                <i class="icon-check"></i>
            </div>
            <div
                v-show="!isServiceSelected && savedSelectedService > 0"
                class="card-body-saved"
                :style="'background-color:' + MainUISettings.button_color"
            >
                <span class="card-body-saved__count skiptranslate">{{savedSelectedService}}</span>
                <span class="icon-simple icon-simple--circle icon-simple--bordered icon-simple--minus icon-simple--bordered--primary" @click="clearBookingService($event)"></span>
            </div>
        </div>
    </div>
</template>

<script>

import ColorFilter from '../../../../common/components/ColorFilter';

export default {
  components: {
    ColorFilter
  },
  data(){
    return {
      pubPath: process.env.MIX_APP_URL,
    }
  },
  props: {
    index : Number,
    service: Object,
    serviceLength : Number,
    selectedServiceId: Number,
    effectiveEntitlements : Object,
    entitlementGroupSettings : Object,
    bookingState: Object,
    isFreeServiceRemaining: Object
  },
  computed: {
    MainUISettings() {
      return this.$store.getters["GET_MAIN_UI"];
    },
    isServiceSelected() {
      return this.service.service_setting_id == this.selectedServiceId;
    },
    isServiceEntitled(){
      var service = this.service
      var entitlementGroupSettings = this.entitlementGroupSettings
      var effectiveEntitlements = this.effectiveEntitlements;
      
      // --- Default Case: service doesn't have any entitlement
      if(!service.entitlement_setting_id || !entitlementGroupSettings){
        return true;
      }
      // --- Default Case: there are no entitlements at all
      else if(!effectiveEntitlements){
        return false;
      }

      var isServiceEntitled = false;
      
      // --- Case: If Usage is set to CollectionDate
      if(entitlementGroupSettings.entitlement_usage == 1){
        isServiceEntitled = effectiveEntitlements[service.entitlement_setting_id] && effectiveEntitlements[service.entitlement_setting_id] >= 1
      }
      // --- Case: If Usage is set to BookingDate OR usage isn't set at all
      else if(!entitlementGroupSettings.entitlement_usage || entitlementGroupSettings.entitlement_usage == 2){
        // Check if there's current entitlement period (available booking dates bound) usable
        isServiceEntitled = effectiveEntitlements.current && effectiveEntitlements.current[service.entitlement_setting_id] && effectiveEntitlements.current[service.entitlement_setting_id] >= 1

        // If type of booking is set to booking date
        // Check raw entitlement setting from API if still has entitlement for current period (not available booking dates bound)
        const currentEntitlementPeriodHasRemaining = this.checkRawCurrentEntitlementPeriodsOfThisService(service.entitlement_setting_id);
        if (entitlementGroupSettings.entitlement_usage == 2 && !isServiceEntitled ) {
            isServiceEntitled = currentEntitlementPeriodHasRemaining;
        }
      }
      
      return isServiceEntitled
    },
    isDisabledForFreeServiceRemaining() {
      return !!this.isFreeServiceRemaining && this.isFreeServiceRemaining.service_name && this.service.is_paid == 2;
    },
    toolTipMessage() {
      if(!this.isServiceEntitled){
        return "You do not have entitlements to use this service.";
      }
      else if (this.isDisabledForFreeServiceRemaining && this.isFreeServiceRemaining && this.isFreeServiceRemaining.service_name) {
        return this.isFreeServiceRemaining.service_name + " still remaining";
      } else {
        return "";
      }
    },

    serviceCardStyle() {
      var buttonColor = this.$store.getters["GET_MAIN_UI"].button_color;

      return this.isServiceSelected
        ? {
            border: "1px solid " + buttonColor,
            'border-color' : buttonColor + '!important',
            "background-color": this.convertHex(buttonColor)
          }
        : null;
    },
    savedSelectedService() {
      // Get Products by Service Group. Then Group by Service Setting ID
      const serviceSettings = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS
        .filter(product =>
          product.service_group_id === this.service.service_group_id
          && product.service_setting_id === this.service.service_setting_id
          && !product.isParent)
        .reduce((r, a) => {
         r[a.service_setting_id] = [...r[a.service_setting_id] || [], a];
         return r;
        }, {});

      const found = serviceSettings[this.service.service_setting_id];
      return found ? found.length : 0;
    },
    entitlementSummary() {
      return (this.bookingState && this.bookingState.entitlementSummary) || {};
    }
  },
  methods : {
      checkRawCurrentEntitlementPeriodsOfThisService(entitlement_setting_id) {
        const { currentPeriod } = this.entitlementSummary;

        if (!currentPeriod) {
          return false;
        }

        // Entitlements remaining here does not bound by the current available booking dates returned by API.
        // It's the actual standing balances of the current address's entitlements based of JDE's record.
        // We just need to check the Current entitlement balance for `booking date` type service transaction.
        return currentPeriod && currentPeriod.entitlementsRemaining && currentPeriod.entitlementsRemaining[entitlement_setting_id] >= 1;
      },
        convertHex(color) {
            color = color.replace('#', '')
            let r = parseInt(color.substring(0, 2), 16)
            let g = parseInt(color.substring(2, 4), 16)
            let b = parseInt(color.substring(4, 6), 16)
            let result = 'rgba(' + r + ',' + g + ',' + b + ',' + 0.05 + ')'
            return result
        },
        selectServiceKeyEvent(event){
          if (event.keyCode == 32 || event.keyCode == 13) {
            event.preventDefault();
            this.$emit('keyEvent')
          }
        },
        clearBookingService(event) {
          let service_group_id = this.service.service_group_id;
          let service_setting_id = this.service.service_setting_id;
          this.$parent.$emit('showConfirmClearGroup', {
            service_group_id,
            service_setting_id
          });

          event.preventDefault();
          event.stopPropagation();
        }
  }
};
</script>
